'use strict';

var _ = require('lodash');
var DemandPostingConfirmationModalController = function DemandPostingConfirmationModalController($rootScope, $scope, dataRetrieverService) {
  $scope.summary = {
    sourceRows: 0,
    sourceOverrides: 0,
    targetRows: 0,
    targetOverrides: 0
  };
  $scope.isRowCountValid = true;
  $scope.isSourceOverrideCountValid = true;
  $scope.isTargetOverrideCountValid = true;
  function getClassGrp(operation, mode) {
    var key = mode === 'source' ? 'sourceProductGroup' : 'targetProductGroup';
    return operation[key] && operation[key].selectedItem && operation[key].selectedItem.id;
  }
  function getClassGroupFilters(operations) {
    return _.reduce(operations, function (result, operation) {
      result.sourceClassGroups[getClassGrp(operation, 'source')] = true;
      result.targetClassGroups[getClassGrp(operation, 'target')] = true;
      return result;
    }, {
      sourceClassGroups: {},
      targetClassGroups: {}
    });
  }
  function hasDemandOverride(row) {
    var overrideKey = !$scope.dimension || $scope.dimension === 'regular' ? 'userValueRegularRemainingDemandFC' : 'userValueMappedRemainingDemandFC';
    return !_.isNil(row[overrideKey]);
  }
  $scope.loadGridData = function () {
    return dataRetrieverService.getDataRetriever($scope.gridParams.screen, $scope.gridParams.mode).retrieveComponentData($scope.gridParams.gridId);
  };
  $scope.calculateSummary = function (market) {
    $scope.filters = getClassGroupFilters($scope.operations);
    $scope.loadGridData().then(function (data) {
      $scope.summary = _.chain(data).filter(function (o) {
        return market === o.market;
      }).reduce(function (result, row) {
        if ($scope.filters.sourceClassGroups[row.classGroup]) {
          result.sourceRows++;
          if (hasDemandOverride(row)) {
            result.sourceOverrides++;
          }
        }
        if ($scope.filters.targetClassGroups[row.classGroup]) {
          result.targetRows++;
          if (hasDemandOverride(row)) {
            result.targetOverrides++;
          }
        }
        return result;
      }, {
        sourceRows: 0,
        sourceOverrides: 0,
        targetRows: 0,
        targetOverrides: 0
      }).value();
      $scope.isRowCountValid = $scope.summary.sourceRows === $scope.summary.targetRows;
      $scope.isSourceOverrideCountValid = $scope.summary.sourceOverrides === 0;
      $scope.isTargetOverrideCountValid = $scope.summary.targetOverrides === 0;
    });
  };
};
DemandPostingConfirmationModalController.$inject = ['$rootScope', '$scope', 'DataRetrieverService'];
module.exports = DemandPostingConfirmationModalController;